module.exports = __webpack_public_path__ + "static/media/plantRecognition.e81c157e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dashboard/plantRecognition.jpg
// module id = 532
// module chunks = 0